import { Autocomplete, Checkbox, FormControlLabel, Grid, Paper, TextField } from '@mui/material'
import type { ManufacturerFilters as ManufacturerFiltersType } from './ManufacturerList.types'
import './ManufacturerFilters.css'

export interface ManufacturerFiltersProps {
  filters: ManufacturerFiltersType
  onFiltersChange: (filters: ManufacturerFiltersType) => void
  manufacturerOptions: string[]
}

export function ManufacturerFilters({ filters, onFiltersChange, manufacturerOptions }: ManufacturerFiltersProps) {
  const updateFilter = (key: keyof ManufacturerFiltersType, value: string | boolean) => {
    onFiltersChange({ ...filters, [key]: value })
  }

  return (
    <Paper elevation={0} className="manufacturer-filters-paper">
      <form onSubmit={e => e.preventDefault()}>
        <Grid container spacing="24px" alignItems="center">
          <Grid size={3}>
            <Autocomplete
              options={manufacturerOptions}
              value={filters.manufacturer || null}
              onChange={(_event, newValue) => updateFilter('manufacturer', newValue ?? '')}
              clearOnEscape
              renderInput={params => <TextField {...params} label="Manufacturers" size="small" fullWidth />}
            />
          </Grid>

          <Grid size={2.5}>
            <TextField
              fullWidth
              size="small"
              label="Alias"
              value={filters.alias}
              onChange={e => updateFilter('alias', e.target.value)}
            />
          </Grid>

          <Grid size={2.5}>
            <TextField
              fullWidth
              size="small"
              label="OEM Code"
              value={filters.oemCode}
              onChange={e => updateFilter('oemCode', e.target.value)}
            />
          </Grid>

          <Grid size={3}>
            <TextField
              fullWidth
              size="small"
              label="URL"
              value={filters.url}
              onChange={e => updateFilter('url', e.target.value)}
            />
          </Grid>

          <Grid size={1}>
            <FormControlLabel
              label="Direct"
              control={
                <Checkbox
                  checked={filters.direct}
                  onChange={e => updateFilter('direct', e.target.checked)}
                  size="small"
                />
              }
            />
          </Grid>
        </Grid>
      </form>
    </Paper>
  )
}
